import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  constructor(private http: HttpClient) {}

  getLabel(csvPath) {
    const path = csvPath ? csvPath : 'assets/data/label.json';
    return this.http.get(path);
  }
}
